import * as v from 'valibot';
import Ajax from '../util/ajax';
import { zigbeeNodesUpdateEndpointGroups } from '../features/zigbee_nodes/zigbeeNodesSlice';
import { groupsSchema } from '../types/Zigbee/Groups';
export function fetchZigbeeNodeEndpointGroups(zigbee_node_id, eid) {
    return (dispatch) => {
        const ajax = new Ajax(dispatch);
        const url = '/zigbee/' + zigbee_node_id + '/ep/' + eid + '/groups';
        ajax.post(url, {}, data => {
            const res = v.safeParse(groupsSchema, data);
            if (res.success) {
                const groups = res.output;
                dispatch(zigbeeNodesUpdateEndpointGroups(zigbee_node_id, eid, groups));
            }
            else {
                console.error(v.summarize(res.issues));
            }
        });
    };
}
